export default __webpack_public_path__ + "static/media/atb.2dd4b971.svg";